import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import startsWith from 'lodash/startsWith';
import get from 'lodash/get';
import { useLocationPageNames, useWindowSize } from 'modules/core';
import { NavBar, NavBarLink } from 'modules/ui';
import {
  AccountAvatarMenu,
  AccountNavBarEnvelope,
  MobileNavBarAccountCard,
  TALENT_PAGES,
} from 'modules/accounts';
import { getTalent } from '../redux';
import { useLocation, useNavigate } from 'react-router-dom';

function TalentNavBar({ avatar, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = useLocationPageNames(TALENT_PAGES.PAGES);
  // eslint-disable-next-line no-unused-vars
  const { desktopWidth, mobileWidth } = useWindowSize();
  const [drawerExpanded, setDrawerExpanded] = useState(false);
  const talent = useSelector(getTalent);

  const fullName = get(talent, 'fullName');
  const city = get(talent, 'city');
  const state = get(talent, 'state.name');
  const country = get(talent, 'country.name');

  function handleLogoutClick() {
    onLogout();
    setDrawerExpanded(false);
  }

  function handleProfileClick() {
    setDrawerExpanded(false);
    navigate('/profile');
  }

  function handleEditProfileClick() {
    setDrawerExpanded(false);
    navigate('/profile/edit');
  }

  function handleSettingsClick() {
    setDrawerExpanded(false);
    navigate('/settings/change-password');
  }

  function NavBarComponents() {
    return (
      <>
        <NavBarLink
          to="/"
          showUnderline={desktopWidth}
          isExtraUrlMatch={
            location.pathname === '/' ||
            startsWith(location.pathname, '/auditions')
          }
          onClick={() => setDrawerExpanded(false)}
        >
          Auditions
        </NavBarLink>
        {desktopWidth && (
          <NavBarLink
            showUnderline={desktopWidth}
            to="/submissions"
            onClick={() => setDrawerExpanded(false)}
          >
            My Submissions
          </NavBarLink>
        )}
        <NavBarLink
          showUnderline={desktopWidth}
          to="/offers"
          onClick={() => setDrawerExpanded(false)}
        >
          Offers
        </NavBarLink>
        {!desktopWidth ? (
          <MobileNavBarAccountCard
            avatar={avatar}
            fullName={fullName}
            city={city}
            state={state}
            country={country}
            onLogout={handleLogoutClick}
            onProfile={handleProfileClick}
          />
        ) : (
          <>
            <AccountNavBarEnvelope />
            <AccountAvatarMenu
              avatar={avatar}
              fullName={fullName}
              city={city}
              state={state}
              country={country}
              onLogout={onLogout}
              onProfile={handleProfileClick}
              onEditProfile={handleEditProfileClick}
              onSettings={handleSettingsClick}
              isActive={startsWith(location.pathname, '/profile')}
              enableHoverBorder
            />
          </>
        )}
      </>
    );
  }

  return (
    <NavBar
      activePageName={currentPage}
      rightIconComponent={<AccountNavBarEnvelope />}
      expanded={drawerExpanded}
      handleExpandDrawer={setDrawerExpanded}
      className="pt-4"
      homePagePathname={TALENT_PAGES.HOME_PAGE_PATHNAME}
    >
      <NavBarComponents />
    </NavBar>
  );
}

TalentNavBar.propTypes = {
  avatar: PropTypes.string,
  onLogout: PropTypes.func,
  history: PropTypes.object,
};

export default TalentNavBar;
